
import Loading from 'vux/src/components/loading/index.vue'

import $ from 'zepto'
export default {
name: "actionButton",
components: {Loading},
props: ["preHandle", "nextHandle", "totalCount", 'currentHandle', 'isLoading'],
data() {
return {
dotGoDir: '', //组件动画移动方向
next: 2,
pre: 0,
current: 1,
isShowLoadingBox: false,
btnCanClick: true,  //按键可以按下，动画时不可点击
};
},
watch: {  //监听
isLoading(curVal, oldVal) {
this.isShowLoadingBox = curVal;
}
},
created() {
this.isShowLoadingBox = this.isLoading;
},
methods: {
/*------------------------------------------- 自定义方法 -------------------------------------------------------*/
/*  动画
* @param dir条移动的方向，可以是left或者right
* */
animation(dir) {
this.btnCanClick = false;
const ANIMATION_TIME = 500; //动画时间，毫秒
let $panel = $('.remote-panel').eq(0);
let $panelCopy = $panel.clone();

setTimeout(()=>{  //元素结构复杂，copy和append需要时间，要等dom准备完成
$panelCopy.css({
position: 'absolute',
top: 0,
left: 0,
width: '100%',
height: '100%',
background: '#fff',
animation: 'disappear-from-' + dir + ' ' + ANIMATION_TIME + 'ms ease-in-out forwards',
borderLeft: '1px solid #eee',
borderRight: '1px solid #eee',
paddingBottom: '5rem',
});
$panel.append($panelCopy);
setTimeout(() => {
$panelCopy.remove();
this.btnCanClick = true;
}, ANIMATION_TIME);
}, 0);
},
/*------------------------------------------- 绑定方法 -------------------------------------------------------*/
preClick: function () {
this.animation('left');
this.current = this.current - 1;
this.next = this.next - 1;
this.pre = this.pre - 1;
this.preHandle(this.current);
},
nextClick: function () {
this.animation('right');
this.current = this.current + 1;
this.next = this.next + 1;
this.pre = this.pre + 1;
this.nextHandle(this.current);
},
currentClick: function () {
this.currentHandle(this.current)
}
}
};



// WEBPACK FOOTER //
// ./src/items/actionButton.vue